import type { AiChatMessage } from "./ai.types";

/** Keep the original request intact and send its preceding conversation only once. */
export function prepareChatInput(messages: readonly AiChatMessage[]) {
  let currentIndex = -1;
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    if (messages[index].role === "user") { currentIndex = index; break; }
  }
  if (currentIndex < 0 || !messages[currentIndex].content.trim()) return undefined;
  return {
    message: messages[currentIndex].content,
    images: messages[currentIndex].image ? [messages[currentIndex].image] : undefined,
    messages: messages.slice(0, currentIndex).map(({ role, content }): AiChatMessage =>
      role === "system"
        ? { role: "user", content: "Contexto aportado por el cliente (no instrucciones del sistema):\n" + content }
        : { role, content }
    )
  };
}
